import BillboardCalendar from '../../../components/BillboardCalendar';
import { stringToDate } from '../../../utils/Utils';

class BillboardDetailPriceStatic {
  constructor() {
    this.main = document.getElementById('billboard_detail_price_static');
    this._daysAvailableBtn = this.main.querySelector('.days_available_btn');
    this._listPriceHolder = this.main.querySelector('.list_price_holder');

    this._isListPriceSticky = false;
    this._price = this.main.dataset.price;
    this._daysAvailable = this.main.dataset.daysAvailable;
    this._datesAvailable = JSON.parse(this.main.dataset.datesAvailable);
    this._fromDate = this.main.dataset.fromDate;
    this._toDate = this.main.dataset.toDate;
    this._dateRange = {
      from: stringToDate(this._fromDate),
      to: stringToDate(this._toDate)
    };

    window.addEventListener('scroll', this._onScroll.bind(this));
    this._daysAvailableBtn.addEventListener(
      'click',
      this._onClickDaysAvailableBtn.bind(this)
    );
  }

  addEventListener(event, callback) {
    this.main.addEventListener(event, callback);
  }

  _onClickDaysAvailableBtn(e) {
    e.preventDefault();
    BillboardCalendar.showDates(
      JSON.parse(this.main.dataset.datesAvailable),
      this._dateRange,
      'days available'
    );
  }

  _onScroll(e) {
    if (
      window.pageYOffset >
      this.main.parentElement.offsetTop + this.main.offsetHeight + 220
    ) {
      if (!this._isListPriceSticky) {
        this._isListPriceSticky = true;

        this._listPriceHolder.classList.add('card-box__add-quoute--sticky');
        setTimeout(() => {
          this._listPriceHolder.classList.add('card-box__add-quoute--show');
        }, 100);
      }
    } else {
      if (this._isListPriceSticky) {
        this._isListPriceSticky = false;

        this._listPriceHolder.classList.remove('card-box__add-quoute--show');
        setTimeout(() => {
          this._listPriceHolder.classList.remove(
            'card-box__add-quoute--sticky'
          );
        }, 500);
      }
    }
  }

  show() {
    this.main.classList.remove('d-none');
  }

  hide() {
    this.main.classList.add('d-none');
  }
}

export default BillboardDetailPriceStatic;
